<template>
  <li class="row component-survey-item" :class="containerClass">

      <div class="list-group-item" :class="[showCoach ? 'col-lg-10' : 'col-12']">
        <div class="row">

            <div class="col-12 col-lg-2 overview">
                <div class="overview-top">
                    <h2>{{ kit.name || dateString }}</h2>
                    <h4 class="survey-item-status">Kit {{kit.id}}</h4>
                    <p>{{formattedStatus}}</p>
                </div>

                <div class="progress-wrapper row">
                  <h4 class="col-6 col-sm-5 col-md-12 px-md-0">Overall progress</h4>

                  <div class="progressBar col-6 col-sm-7 col-md-12 px-md-0">
                      <div class="progress">
                          <div v-bind:class="className" role="progressbar" :style="{ width: totalPercent + '%'}" :aria-valuenow="totalPercent" aria-valuemin="0" aria-valuemax="percent">
                              <div class="bar-tick icon-check d-md-none"  v-if="totalPercent === 100"></div>
                          </div>
                      </div>
                  </div>
                </div>
            </div>

            <button class="toggleMobile" @click="isButtonToggled = !isButtonToggled">
              <i v-if="!isButtonToggled" class="down icon-chevron-bottom"></i>
              <i v-if="isButtonToggled"  class="up icon-chevron-top"></i>
            </button>

            <div class="stat-group col-12  d-flex align-items-center" :class="[showCoach ? 'col-lg-8' : 'col-lg-10']">
              <div class="stat-group-inner row d-lg-flex flex-lg-nowrap">
                <SurveyStat v-for="stat in surveyStats" :key="stat.surveyType" :showCoach="showCoach" :stat="stat" :kitId="kit.id"/>
              </div>
            </div>

            <div class="col-lg-2 acknowledge text-center">

              <div class="form-checkbox" :class="{'disabled':  listKitStatuses[kit.sampleStatus] !== listKitStatuses.RESULTS_AVAILABLE}">
                <input
                  :name="kit.id + '-report-recieved'"
                  :id="kit.id + '-report-recieved'"
                  type="checkbox"
                  v-model="kit.reportReceived"
                  :disabled="listKitStatuses[kit.sampleStatus] !== listKitStatuses.RESULTS_AVAILABLE"
                  v-on:change="updateKit()" />
                <label :for="kit.id + '-report-recieved'"></label>
              </div>
              <!--<label for="report-recieved" :class="{'disabled': listKitStatuses[kit.sampleStatus] !== listKitStatuses.RESULTS_AVAILABLE}">I acknowledge I have received my report for this kit</label>-->

              <router-link v-if=" listKitStatuses[kit.sampleStatus] === listKitStatuses.RESULTS_AVAILABLE" :to="'/report/' + kit.id" class="btn btn-block btn-report" :class="reportButtonClass" :disabled="!kit.reportRecieved">View report</router-link>
            </div>

        </div>
      </div>

    <div class="col-lg-2 list-group-item-additional" v-if="showCoach">
        <i class="icon-coach"></i>
        <p>{{coachText}}</p>
        <button v-if="totalPercent >= 100" class="btn btn-primary btn-block" :disabled="!kit.reportReceived" @click="$emit('onClickAppointment')" >Make appointment</button>
    </div>

  </li>
</template>

<script>
import SurveyStat from '@/components/elements/SurveyStat'
import apiStringMappings from '@/mixins/apiStringMapping'
import { kitStatuses } from '@/enums/kitItemStatus'
import moment from 'moment'

export default {
  name: 'SurveyItem',
  mixins: [apiStringMappings],
  components: {
    SurveyStat
  },
  data: function () {
    return {
      isButtonToggled: true
    }
  },
  props: ['kit', 'showCoach'],
  methods: {
    updateKit: function () {
      // You can only mark as true
      console.log('updateKit', this.kit.reportReceived)
      if (this.kit.reportReceived === false) {
        this.kit.reportReceived = true
        return
      }
      const payload = {
        kitId: this.kit.id,
        reportReceived: this.kit.reportReceived
      }
      this.$store.dispatch('updateKit', payload)
      .then(succuess => {
        console.log('succuess')
      })
      .catch(error => {
        console.log('error', error.response.data.message)
      })
    },

    friendlyStatus: function (key) {
      let keys = {
        'ASSIGNED': 'Kit Available',
        'PROCESSING': 'Processing',
        'UNASSIGNED': 'Kit Available',
        'REQUESTED': 'Packing',
        'DISPATCHED_BY_MICROBA': 'Sent',
        'RECEIVED_BY_CUSTOMER': 'Received',
        'RESULTS_AVAILABLE': 'Results Available',
        'FAILED_OVERLOADED': 'Error',
        'REDEEMED': 'Kit Redeemed' // Not from api
      }
      let value = keys[key]
      return (value != null) ? value : key
    }
  },
  computed: {
    surveyStats () {
      const disabledSurvey = [
        'INFANT_MEDICAL_HISTORY',
        'INFANT_DAY_OF_SAMPLING',
        'INFANT_DEMOGRAPHIC_AND_MILK_FEEDING'
      ]
      return this.kit.surveysStats.filter(
        survey => disabledSurvey.indexOf(survey.surveyType) === -1
      )
    },
    listKitStatuses () {
      return kitStatuses
    },
    containerClass: function () {
      return this.isButtonToggled ? 'active' : ''
    },
    formattedStatus: function () {
      return this.friendlyStatus(this.kit.kitStatus)
    },

    dateString: function () {
      var dateKey = null
      if (this.kit.activatedDate) {
        dateKey = this.kit.activatedDate
      } else if (this.kit.redeemedDate) {
        dateKey = this.kit.redeemedDate
      } else {
        // If all date keys are empty - fall back to todays as a default.
        dateKey = new Date()
      }
      const theDate = moment(dateKey)
      const month = theDate.format('MMMM')
      const year = theDate.format('Y')
      return month + ' ' + year
    },
    totalPercent: function () {
      // Check all answerd / total questions. If > 100 return true
      const total = this.kit.surveysStats.reduce((acc, el) => {
        const val = Number(el.totalQuestions)
        return acc + val
      }, 0)
      const completed = this.kit.surveysStats.reduce((acc, el) => {
        const val = Number(el.completedQuestions)
        return acc + val
      }, 0)
      return completed / total * 100
    },
    className: function () {
      return (this.totalPercent === 100) ? 'progress-bar bg-success' : 'progress-bar bg-info'
    },
    coachIconColor: function () {
      return (this.totalPercent >= 100) ? '#5CD69F' : '#B0B6C0'
    },
    coachText: function () {
      return (this.totalPercent >= 100) ? 'You now have access to your Microbiome Coach' : 'Complete your questionnaires to receive your report and gain access to your Microbiome Coach'
    },
    reportButtonClass: function () {
      return (this.reportRecieved) ? 'btn-outline-primary' : 'btn-outline-light'
    }
  }
}
</script>

<style scoped lang='scss'>
.form-checkbox{
  width: 20px;
 margin: 1rem auto 1rem;
}
li.row{
  margin-bottom: 2rem;
}
h2{
  margin: 0 0 10px 0;
  font-weight: 500;
}

.survey-item-status {
    margin-bottom:0;
}


.list-group-item{
  margin-bottom: 0px;
  padding: 1.5rem 1.25rem 1.5rem 1.25rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  border-radius: 4px;
  z-index: 1;
}
.simple-svg-wrapper {
  display: block;
}

.icon-coach{
  font-size: 40px;
  margin-bottom: 10px;
  color: #5CD69F;
}

.disabled{
  opacity: 0.2;
}


.locked{
  justify-content: center;
  justify-items: center;
  align-items: center;
  flex-direction: column;
  display: flex;
  height: 100%;
}

.details{
    flex-direction: column;
  display: flex;
  height: 100%;
    justify-content: center;
  justify-items: center;
}
.lock {
  text-align: center;
  font-size: 10px;
  .oi {
    font-size: 36px;
    color: #778598;
    display: block;
    margin-bottom: 10px;

  }
    .unlocked .oi {
      color: #5CD69F;
    }
    .locked-unassigned .oi {
      opacity: 0.2;
    }
}
.buttons{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-right: 15px;
  padding-left: 15px;
}

.btn{
  display: block;
  width: 100%;
  margin-bottom: 10px;

  &:last-of-type{
    margin-bottom: 0;
  }
}
.btn.btn-block{
padding-left: 5px !important;
  padding-right: 5px !important;
  max-width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/SurveyItem.vue